import { render } from "./SignupPassword.vue?vue&type=template&id=dde91790"
import script from "./SignupPassword.vue?vue&type=script&lang=js"
export * from "./SignupPassword.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__